import EnrollmentVideoTabs from '@/components/EnrollmentVideoTabs';
import InteractiveFlowChart from '@/components/InteractiveFlowChart';
import SEOHead from '@/components/SEOHead';
import VMCBenefits from '@/components/VMCBenefits';
import VMCPrepare from '@/components/VMCPrepare';
import VMCPricing from '@/components/VMCPricing';
import VMCVideo from '@/components/VMCVideo';
import VMCWhichOne from '@/components/VMCWhichOne';
import { Col, Row, Typography } from 'antd';
import { motion } from 'framer-motion';
import Image from 'next/image';

const { Title, Paragraph, Text } = Typography;

const HowItWorks = () => {
  return (
    <div>
      <SEOHead />
      <section className="section hero v9 mg-bottom-48px">
        <div className="container-default w-container">
          <div className="inner-container _700px---tablet center">
            <div className="w-layout-grid grid-2-columns text-left-default vmc-product">
              <Row gutter={[48, 48]}>
                <Col xs={24} lg={14}>
                  <div className="product-page">
                    <div className="mg-bottom-16px">
                      <div className="flex-horizontal product-page-title">
                        <div className="mg-bottom-8px">
                          <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5 }}
                          >
                            <div className="text-100 bold color-accent-1 text-uppercase">
                              How Mark Certificates Work
                            </div>
                          </motion.div>
                        </div>
                        <motion.h2
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.5, delay: 0.1 }}
                          className="display-1 color-neutral-100 mg-bottom-0"
                        >
                          What exactly is a Mark Certificate?
                        </motion.h2>
                      </div>
                    </div>
                    <div className="inner-container">
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                      >
                        <p className="color-neutral-300 mg-bottom-24px paragraph-large">
                          A Mark Certificate (VMC, CMC, or GMC) lets you display your official logo
                          in emails, proving your brand's authenticity. Paired with DMARC, it
                          enhances email security, builds customer trust, and protects against
                          phishing—ensuring your emails stand out safely.
                        </p>
                      </motion.div>
                      <div className="w-layout-grid grid-1-column bullet-list">
                        <motion.div
                          key="1"
                          className="feature-wrapper"
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.5, delay: 0.3 }}
                        >
                          <div className="line-rounded-icon feature-icon"></div>
                          <div className="text-200 medium color-neutral-300 paragraph-large">
                            Display your verified logo and a blue checkmark (with VMC), proving your
                            brand's authenticity.
                          </div>
                        </motion.div>

                        <motion.div
                          key="2"
                          className="feature-wrapper"
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.5, delay: 0.4 }}
                        >
                          <div className="line-rounded-icon feature-icon"></div>
                          <div className="text-200 medium color-neutral-300 paragraph-large">
                            Enhance email security with DMARC to protect against phishing.
                          </div>
                        </motion.div>

                        <motion.div
                          key="3"
                          className="feature-wrapper"
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.5, delay: 0.5 }}
                        >
                          <div className="line-rounded-icon feature-icon"></div>
                          <div className="text-200 medium color-neutral-300 paragraph-large">
                            Build customer trust and stand out in crowded inboxes.
                          </div>
                        </motion.div>

                        <motion.div
                          key="4"
                          className="feature-wrapper"
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.5, delay: 0.6 }}
                        >
                          <div className="line-rounded-icon feature-icon"></div>
                          <div className="text-200 medium color-neutral-300 paragraph-large">
                            Increase engagement with a trusted brand presence.
                          </div>
                        </motion.div>

                        <motion.div
                          key="5"
                          className="feature-wrapper"
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.5, delay: 0.7 }}
                        >
                          <div className="line-rounded-icon feature-icon"></div>
                          <div className="text-200 medium color-neutral-300 paragraph-large">
                            Trusted by 10,000+ brands to secure their emails. [Learn more].
                          </div>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={24} lg={10} className="product-column">
                  <div className="inner-container _598px _100---tablet product-module">
                    <motion.div
                      className="vmc-phone-your-logo-here"
                      style={{ maxWidth: '100%' }}
                      initial={{ opacity: 0, scale: 1 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.5, delay: 0.3 }}
                    >
                      <Image
                        src="/images/brandymail-bimi-vmc-home2b.svg"
                        loading="eager"
                        alt="Display your verified logo in emails, proving your brand's authenticity - Brandymail.com"
                        className="image cover"
                        height={259 * 2}
                        width={248 * 2}
                        style={{ height: 'auto' }}
                      />
                    </motion.div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="products section hero v9" style={{ paddingBottom: '0' }}>
        <div className="container-default w-container inner-container center">
          <VMCHowItWorks />
        </div>
        <div className="position-absolute card-top-bg---bottom pricing-bg" />
      </section> */}

      <div className="overflow-hidden border-radius-40px---bottom">
        {/* <section className="section pd-top-0px bg-neutral-100 pd-0px">
          <div className="container-default w-container inner-container center">
            <VMCWhatIsIt />
          </div>
        </section> */}

        {/* <section className="section bg-neutral-100 pd-100px">
          <div className="container-default w-container inner-container center">
            <VMCHowItWorks />
          </div>
        </section> */}

        {/* <section className="section bg-neutral-100 pd-100px">
          <div className="container-default w-container inner-container center">
            <EnrollmentVideoTabs />
          </div>
        </section> */}

        <section className="section light pd-100px">
          <div className="container-default w-container inner-container center">
            <VMCVideo />
          </div>
        </section>

        {/* New section for the Interactive Flow Chart */}
        <section className="section light pd-100px bg-neutral-100">
          <div className="container-default w-container">
            <div className="inner-container _700px---tablet center">
              <div className="mg-bottom-24px">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  <div
                    className="text-100 bold color-accent-1 text-uppercase text-center"
                    style={{ marginBottom: '20px' }}
                  >
                    Unlock Trusted Email Branding
                  </div>
                </motion.div>
                <motion.h3
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <div className="display-2 text-center">Simple 5-Step Verification Process</div>
                </motion.h3>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                >
                  <p className="color-neutral-600 mg-bottom-40px paragraph-large text-center">
                    Follow these steps to get your VMC and display your logo in emails. <br />
                    Hover or tap each step to explore details.
                  </p>
                </motion.div>
              </div>
              <InteractiveFlowChart />
            </div>
          </div>
        </section>

        <section className="section bg-neutral-100 pd-100px pd-bottom-0px">
          <div className="container-default w-container inner-container center">
            <VMCWhichOne />
          </div>
        </section>

        <div className="position-relative">
          <div className="position-relative z-index-1">
            <div className="overflow-hidden border-radius-40px">
              <section className="section cta-v3 pd-100px">
                <div className="container-default w-container inner-container center">
                  <VMCBenefits />
                </div>
              </section>
            </div>
          </div>
          <div className="position-absolute half-bg-top bg-neutral-100"></div>
        </div>

        <section className="section pd-100px">
          <div className="container-default w-container inner-container center">
            <EnrollmentVideoTabs />
            <VMCPrepare />
          </div>
        </section>

        <div className="overflow-hidden border-radius-24px">
          <section className="section pd-188px bg-neutral-800 position-relative">
            <div className="container-default w-container">
              <VMCPricing />
            </div>
            <div className="position-absolute cta-v4-grid-wrapper">
              <div className="position-absolute cta-v4-grid-fade"></div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
